import * as React from 'react';

import cx from 'classnames';
import { debounce, get } from 'lodash';

import Button, { Props as ButtonProps } from 'components/Button';
import Input, { Props as InputProps } from 'components/Input';
import MediaObject from 'components/MediaObject';
import { Omit } from 'utils/tsUtils';

import './SearchExpanding.scss';

export type Props = {
  buttonProps: Partial<ButtonProps>;
  children?: React.ReactNode;
  childrenWhileActive?: (forceRedraw?: boolean) => React.ReactNode;
  className?: string;
  // major issues with the ref type here not being liked.  Unsure on real fix.
  // we should probably not be passing refs down this way anyway.
  inputProps?: Partial<Omit<InputProps, 'ref'>>;
  onCancel?: () => void;
  onChange: (query: string) => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
};

type State = {
  query: string;
  searchActive: boolean;
};

export default class SearchExpanding extends React.Component<Props, State> {
  state: State = {
    query: '',
    searchActive: false,
  };

  search = debounce((query: string) => {
    const { onChange } = this.props;

    onChange(query);
  }, 200);

  handleCancel = () => {
    const { onCancel } = this.props;

    this.setState({
      query: '',
      searchActive: false,
    });

    if (onCancel) {
      onCancel();
    }
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    this.setState({ query: value });

    this.search(value);
  };

  render() {
    const {
      buttonProps,
      children,
      className,
      inputProps,
      onClick,
      childrenWhileActive,
    } = this.props;
    const { query, searchActive } = this.state;

    return (
      <div className="SearchExpanding">
        <div
          className={cx(
            'SearchExpanding-inputWrap',
            searchActive && 'SearchExpanding-inputWrap--active',
            className
          )}>
          <Input
            {...inputProps}
            button
            glyph="search"
            placeholder={get(inputProps, 'placeholder') || 'Search'}
            value={query}
            className="SearchExpanding-input"
            onFocus={() => this.setState({ searchActive: true })}
            onChange={this.handleChange}
            onClick={onClick}
          />
        </div>
        {searchActive ? (
          <MediaObject gutter="xsmall">
            <Button {...buttonProps} onClick={this.handleCancel}>
              Cancel
            </Button>
            {childrenWhileActive && childrenWhileActive(true)}
          </MediaObject>
        ) : (
          children
        )}
      </div>
    );
  }
}
